import FilterModal from './filtersModalContainer';

export default FilterModal;
